import React from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@material-ui/core';
import { makeStyles } from '@knockrentals/knock-shared-web';

const useStyles = makeStyles((theme) => ({
  customPagination: {
    float: 'right',
    overflowX: 'auto',

    '& .MuiTablePagination-input': {
      border: 'none',
    },
    '& .MuiTablePagination-caption': {
      color: theme.palette.text.secondary,
      fontSize: '12px',
    },
    '& .MuiSelect-icon': {
      color: theme.palette.text.secondary,
    },

    '& .MuiTablePagination-actions': {
      '& .Mui-disabled .MuiSvgIcon-root': {
        color: '#E2E3E9',
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.secondary.dark,
      },
    },
  },
}));

const Pagination = ({
  count,
  page,
  onChangePage,
  rowsPerPage,
  onChangeRowsPerPage,
  rowsPerPageOptions,
  labelDisplayedRows,
}) => {
  const classes = useStyles();

  return (
    <TablePagination
      className={classes.customPagination}
      colSpan={3}
      count={count}
      labelDisplayedRows={labelDisplayedRows}
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
    />
  );
};

Pagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  onChangePage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  onChangeRowsPerPage: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  labelDisplayedRows: PropTypes.func,
};

export default Pagination;
